import React from 'react';
import { onlyUpdateForKeys } from 'recompose';
import classNames from 'classnames';
import componentClassnames from './styles/PSSAvatar.scss';
import Thumbnail from '../../legacy/Construction/Thumbnail/Thumbnail';

const PSSAvatar = onlyUpdateForKeys([
  'avatarProps',
  'fullName',
  'tierDisplayLabel',
  'score',
  'hideBadge',
  'color',
  'size',
])(
  ({
    avatarProps = {},
    fullName,
    tierDisplayLabel,
    score,
    hideBadge = false,
    color = {},
    size = 62,
  }) => {
    const { src, alt } = avatarProps;
    const { primary, secondary, tertiary } = color;

    // Calculate dynamic border width based on size
    const borderWidth = size * 0.0525 + 0.7;

    const INVALID_SCORE = -1;
    const hideScore = (score ?? INVALID_SCORE) === INVALID_SCORE;

    return (
      <div
        className={classNames(componentClassnames.PSSAvatar, {
          [componentClassnames['PSSAvatar--withLabel']]: !hideBadge,
        })}
      >
        <div className={componentClassnames.PSSAvatar__container}>
          <div
            className={componentClassnames.PSSAvatar__thumbnailWrapper}
            style={{
              border: `${borderWidth}px solid ${primary}`,
            }}
          >
            <div
              className={componentClassnames.PSSAvatar__thumbnailInner}
              style={{ width: `${size}px`, height: `${size}px` }}
            >
              <Thumbnail src={src} title={alt ?? fullName} widthAuto />
            </div>
          </div>
          {!hideBadge && (
            <div
              className={componentClassnames.PSSAvatar__labelWrapper}
              style={secondary ? { backgroundColor: secondary } : undefined}
            >
              <span
                className={componentClassnames.PSSAvatar__labelText}
                style={tertiary ? { color: tertiary } : undefined}
              >
                {tierDisplayLabel}
              </span>
              {!hideScore && (
                <span
                  className={componentClassnames.PSSAvatar__score}
                  style={primary ? { backgroundColor: primary } : undefined}
                >
                  {score}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default PSSAvatar;
